import { useState } from "react";
import { Layout, Menu, Grid, Button, Drawer } from "antd";
import { Link, useLocation } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import LoginButton from "./LoginButton";
import LogoutButton from "./LogoutButton";
import { useAuth0 } from "@auth0/auth0-react";
import { AUTH0_TOKEN_ROLES_CLAIM, ROLES } from "../config";

const { Header: AntHeader } = Layout;
const { useBreakpoint } = Grid;

const navItems = [
  {
    key: "/jobClientName",
    label: <Link to="/jobClientName" style={{ textDecoration: "none" }}>Job Client Information</Link>,
  },
  {
    key: "/jobClientEnrichment",
    label: (
      <Link
        to="/jobClientEnrichment"
        style={{
          textDecoration: "none",
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        Job Client Enrichment
        <span
          style={{
            backgroundColor: "#ff4d4f",
            color: "#fff",
            fontSize: "10px",
            fontWeight: 700,
            lineHeight: 1,
            letterSpacing: "0.4px",
            textTransform: "uppercase",
            padding: "3px 6px",
            borderRadius: "999px",
          }}
        >
          New
        </span>
      </Link>
    ),
  },
];

const Header = () => {
  const { isAuthenticated, user } = useAuth0();
  const location = useLocation();
  const screens = useBreakpoint();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const role = user?.[AUTH0_TOKEN_ROLES_CLAIM]?.[0];
  const isPremiumMember = isAuthenticated && role === ROLES.MEMBER_PREMIUM;
  const isMobile = !screens.md;
  const showLogin = !isAuthenticated && location.pathname === "/admin";

  if (!isMobile) {
    return (
      <AntHeader
        style={{
          backgroundColor: "transparent",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <Link to="/" style={{ display: "flex", alignItems: "center" }}>
          <img
            src={`${process.env.PUBLIC_URL}/upfellow-logo.png`}
            alt="UpFellow Logo"
            width={50}
          />
        </Link>

        {isPremiumMember && (
          <Menu
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={navItems}
            style={{
              flex: 1,
              border: "none",
              backgroundColor: "transparent",
              marginLeft: "24px",
            }}
          />
        )}

        <div>
          {isAuthenticated && <LogoutButton />}
          {showLogin && <LoginButton />}
        </div>
      </AntHeader>
    );
  }

  return (
    <AntHeader
      style={{
        backgroundColor: "transparent",
        padding: "0 12px",
        height: "auto",
        lineHeight: "normal",
      }}
    >
      <div
        style={{
          minHeight: "64px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <Link to="/" style={{ display: "flex", alignItems: "center" }}>
          <img
            src={`${process.env.PUBLIC_URL}/upfellow-logo.png`}
            alt="UpFellow Logo"
            width={50}
          />
        </Link>

        <div
          style={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {isPremiumMember && (
            <Button
              icon={<MenuOutlined />}
              onClick={() => setIsMenuOpen(true)}
              aria-label="Open navigation"
            />
          )}
          {isAuthenticated && <LogoutButton />}
          {showLogin && <LoginButton />}
        </div>
      </div>

      {isPremiumMember && (
        <Drawer
          title="Navigation"
          placement="right"
          onClose={() => setIsMenuOpen(false)}
          open={isMenuOpen}
        >
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            items={navItems}
            onClick={() => setIsMenuOpen(false)}
          />
        </Drawer>
      )}
    </AntHeader>
  );
};

export default Header;
